import styled from 'styled-components'
import { DateRange } from 'react-date-range'

export const StyledPicker = styled(DateRange)`
  position: absolute;
  top: 3.5em;
  left: 0;
  z-index: 1;
`
